const projectRegistry = [
    '5ibTc761cQ1mDAomiPNT8tPMREr2RrDL77qfFsWxLkc1', //TAG verified creator id
    '5g3T8224Ha5as4Ho7tcRxsHQFr4pzeEa1wEtnir93m3t', //Scalp verified creator id
    'C88kKdEmTrCh43GC1w3BUFLsW3oKMEWWBGCyweQAaEYa', //Droid
    'VjJvfLN6h9EUaqJRLHt2aVRDLarDXPTPPrQBmvN8YLh', //SMU
];

export default projectRegistry;